var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.781 6.282a.75.75 0 0 0-1.06-1.06l-3.718 3.719-3.722-3.722a.75.75 0 0 0-1.06 1.06l3.72 3.718-3.722 3.722a.75.75 0 0 0 1.06 1.06l3.718-3.72 3.722 3.723a.75.75 0 0 0 1.06-1.06l-3.72-3.718z"
  })));
};
export default SvgX;